export default {
  loadingHeader: false,
  balance: 0,
  title: "",
  numOfUnReadMessage: 0,
  errorMessagesHeader: []
};
